// Reminder action types
export const CREATE_REMINDER = "CREATE_REMINDER";
export const FETCH_REMINDERS = "FETCH_REMINDERS";
export const FETCH_REMINDER_BY_ID = "FETCH_REMINDER_BY_ID";
export const UPDATE_REMINDER = "UPDATE_REMINDER";
export const DELETE_REMINDER = "DELETE_REMINDER";
export const COMPLETE_REMINDER = "COMPLETE_REMINDER";
export const SNOOZE_REMINDER = "SNOOZE_REMINDER";
export const FETCH_REMINDER_CALENDAR = "FETCH_REMINDER_CALENDAR";
export const FETCH_REMINDER_QUEUE = "FETCH_REMINDER_QUEUE";
export const FETCH_REMINDER_LOGS = "FETCH_REMINDER_LOGS";
export const EXPORT_REMINDERS = "EXPORT_REMINDERS";

// Success/Failure types (optional)
export const API_SUCCESS = "API_SUCCESS";
export const API_FAILURE = "API_FAILURE";
